export const initAfterCookieBanner = (setPromptRedirectAfterCookie: (value: boolean) => void) => {
  if (typeof window === 'undefined') return;

  window.initAfterCookieBanner = () => {
    setPromptRedirectAfterCookie(true);
  };
};
